import React from 'react';
import { XIcon } from 'lucide-react';
import { Eyebrow } from './ui/Eyebrow';
import { painPoints } from '../data/content';
export function PainSection() {
  return <section className="border-b border-line bg-cream" data-id="element-180" data-mp="38vki6mduy1yy">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-181" data-mp="2uxdqxp3ez089">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20" data-id="element-182" data-mp="2yzh5wnpakmya">
          <div data-id="element-183" data-mp="2z1lirv564wap">
            <Eyebrow data-id="element-184" data-mp="2l8c9rvl4ucsp">La realidad de enseñar música</Eyebrow>
            <h2 className="mt-4 font-condensed text-4xl uppercase leading-[0.95] tracking-tight text-ink sm:text-5xl" data-id="element-185" data-mp="2l71944mzhl5t">
              ¿Te suena familiar?
            </h2>
            <p className="mt-5 font-display text-xl italic leading-snug text-accent" data-id="element-186" data-mp="2bb7nzwv78jcf">
              ¿Cuánto tiempo más vas a seguir improvisando cada clase?
            </p>
            <p className="mt-5 max-w-prose text-[15px] leading-relaxed text-ink-soft" data-id="element-187" data-mp="229qbspkwx1t0">
              Lo entendemos. Tu tiempo debería estar puesto en enseñar y cambiar vidas — no atrás
              de una pantalla maquetando fichas.
            </p>
          </div>

          <ul className="divide-y divide-line border-y border-line" data-id="element-188" data-mp="3rp3ukyuu05q5">
            {painPoints.map(point => <li key={point} className="flex items-start gap-4 py-4" data-id="element-189" data-mp="3nl5qsauka6qr">
                <span aria-hidden="true" className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-soft text-accent" data-id="element-190" data-mp="5ehqcyagi7rf">
                  <XIcon className="h-3.5 w-3.5" data-id="element-191" data-mp="38wj57reccir3" />
                </span>
                <p className="text-[15px] leading-relaxed text-ink" data-id="element-192" data-mp="38wsybnuon610">{point}</p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}